/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.avatars.rpc.AvatarsRpc
 */

/**
 *  A single by-id avatar request. {@code fileManagerKey} and {@code knownPropertyValue} are optional hints
 *  to skip the CrmObjects lookup; see {@code resolveAvatarsById} for the full contract.
 */

export const AvatarIdIdentifierTypename = 'com.hubspot.avatars.models.resolver.AvatarIdIdentifier';
export const AvatarIdIdentifierDiscriminant = 'objectId';
export const AvatarIdIdentifierDiscriminantKey = 'identifierType';
export const AvatarIdentifierDiscriminantKey = 'identifierType';
export const AvatarUniquePropertyIdentifierTypename = 'com.hubspot.avatars.models.resolver.AvatarUniquePropertyIdentifier';
export const AvatarUniquePropertyIdentifierDiscriminant = 'uniqueProperty';
export const AvatarUniquePropertyIdentifierDiscriminantKey = 'identifierType';
export const resolveAvatarsByIdRpc = {
  serviceName: 'com.hubspot.avatars.rpc.AvatarsRpc',
  rpcName: 'resolveAvatarsById',
  auth: 'app',
  fingerprint: 'aqRfEKrChVkK_Yyg1kepDj5RieILNF9x',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const resolveAvatarsByUniquePropertyRpc = {
  serviceName: 'com.hubspot.avatars.rpc.AvatarsRpc',
  rpcName: 'resolveAvatarsByUniqueProperty',
  auth: 'app',
  fingerprint: 'b2bbo9tJCAoA95zYAZg3WD5RieILNF9x',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const resolveAvatarsByIdentifierRpc = {
  serviceName: 'com.hubspot.avatars.rpc.AvatarsRpc',
  rpcName: 'resolveAvatarsByIdentifier',
  auth: 'app',
  fingerprint: 'D0Fr_TG8OdFqv6J76RZKmD5RieILNF9x',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const resolveHubspotUserAvatarsRpc = {
  serviceName: 'com.hubspot.avatars.rpc.AvatarsRpc',
  rpcName: 'resolveHubspotUserAvatars',
  auth: 'app',
  fingerprint: 'mYYb7y78RsSW1B6ow9z0Aj5RieILNF9x',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const setAvatarOverrideRpc = {
  serviceName: 'com.hubspot.avatars.rpc.AvatarsRpc',
  rpcName: 'setAvatarOverride',
  auth: 'app',
  fingerprint: 'wQZmhEFGh-Vxmk2FZ3nHzj5RieILNF9x',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const clearAvatarOverrideRpc = {
  serviceName: 'com.hubspot.avatars.rpc.AvatarsRpc',
  rpcName: 'clearAvatarOverride',
  auth: 'app',
  fingerprint: 'czz3M3JpepZxmk2FZ3nHzj5RieILNF9x',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const generateSignedUriByIdRpc = {
  serviceName: 'com.hubspot.avatars.rpc.AvatarsRpc',
  rpcName: 'generateSignedUriById',
  auth: 'app',
  fingerprint: 'a33Q9cxUIjkMHvbV7t9IFj5RieILNF9x',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const generateSignedUriByUniquePropertyRpc = {
  serviceName: 'com.hubspot.avatars.rpc.AvatarsRpc',
  rpcName: 'generateSignedUriByUniqueProperty',
  auth: 'app',
  fingerprint: '5W4BeOuh5rwMHvbV7t9IFj5RieILNF9x',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const generateHubspotUserSignedUriRpc = {
  serviceName: 'com.hubspot.avatars.rpc.AvatarsRpc',
  rpcName: 'generateHubspotUserSignedUri',
  auth: 'app',
  fingerprint: 'hm7eKPSXQZMMHvbV7t9IFj5RieILNF9x',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};